/**
 * La función de traducción, sin React de por medio.
 *
 * Está separada del provider para que se pueda probar —y usar desde código
 * que no es un componente, como un formateador de errores— sin montar el
 * árbol entero.
 */
import { DEFAULT_LANGUAGE, type Language } from './languages';
import { MESSAGES, type MessageKey } from './messages';

export type Translate = (key: MessageKey, vars?: Record<string, string | number>) => string;

/** Sustituye `{nombre}` por su valor. Un `{nombre}` sin valor queda tal cual. */
export function interpolate(template: string, vars?: Record<string, string | number>): string {
  if (vars === undefined) return template;
  return template.replace(/\{(\w+)\}/g, (whole, name: string) => {
    const value = vars[name];
    return value === undefined ? whole : String(value);
  });
}

/**
 * Traductor de un idioma, con respaldo en español y, si tampoco está, en la
 * propia clave: una clave visible en pantalla es un error obvio de
 * traducción; una cadena vacía pasa desapercibida hasta que un cliente la ve.
 */
export function translator(language: Language): Translate {
  const primary = MESSAGES[language];
  const fallback = MESSAGES[DEFAULT_LANGUAGE];
  return (key, vars) => interpolate(primary[key] || fallback[key] || key, vars);
}
